import { useSelector } from 'react-redux';
import { selectExperiments } from '../selectors/experiments';

export const useExperimentByName = (name: string): string | undefined => {
  const experiments = useSelector(selectExperiments);

  return experiments.find(({ experimentName }) => experimentName === name)?.groupName;
};
